"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CNPJ_LENGTH = 14;
var CPF_LENGTH = 11;
var CHECK_SUM_LENGTH = 2;
var CHECK_SUM_MOD = 11;
var CHECK_SUM_COEFFICIENT_MIN = 2;
var CNPJ_COEFFICIENT_LIMIT = 9;

var checkSum = function checkSum(str, len, CNPJ) {
    var j = CHECK_SUM_COEFFICIENT_MIN;

    var sum = 0;

    for (var i = len; i >= 0; i--) {
        sum += parseInt(str.charAt(i), 10) * j;
        j++;
        if (CNPJ) {
            if (j > CNPJ_COEFFICIENT_LIMIT) {
                j = CHECK_SUM_COEFFICIENT_MIN;
            }
        }
    }
    return sum % CHECK_SUM_MOD;
};

/**
 * Validator: Test that a value is a valid CNPJ number.
 *
 * @param str
 * @returns {boolean} is str a valid CNPJ number.
 */
var isCNPJ = exports.isCNPJ = function isCNPJ(str) {
    if (str.length !== CNPJ_LENGTH) {
        return false;
    }
    // check first checkSum
    var r1 = checkSum(str, CNPJ_LENGTH - CHECK_SUM_LENGTH - 1, true);

    r1 = r1 < 2 ? 0 : CHECK_SUM_MOD - r1;
    if (parseInt(str.charAt(CNPJ_LENGTH - CHECK_SUM_LENGTH), 10) !== r1) {
        return false;
    }
    // check second checkSum
    var r2 = checkSum(str, CNPJ_LENGTH - CHECK_SUM_LENGTH, true);

    r2 = r2 < 2 ? 0 : CHECK_SUM_MOD - r2;
    return parseInt(str.charAt(CNPJ_LENGTH - 1), 10) === r2;
};

/**
 * Validator: Test that a value is a valid CPF number.
 *
 * @param str
 * @returns {boolean} is str a valid CPF number.
 */
var isCPF = exports.isCPF = function isCPF(str) {
    if (str.length !== CPF_LENGTH) {
        return false;
    }
    // check first checkSum
    var r1 = checkSum(str, CPF_LENGTH - CHECK_SUM_LENGTH - 1, false);

    r1 = r1 < 2 ? 0 : CHECK_SUM_MOD - r1;
    if (parseInt(str.charAt(CPF_LENGTH - CHECK_SUM_LENGTH), 10) !== r1) {
        return false;
    }
    // check second checkSum
    var r2 = checkSum(str, CPF_LENGTH - CHECK_SUM_LENGTH, false);

    r2 = r2 < 2 ? 0 : CHECK_SUM_MOD - r2;
    return parseInt(str.charAt(CPF_LENGTH - 1), 10) === r2;
};